import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axiosInstance";

export interface RoleAssignmentState {
  data: any[];
  status: boolean;
  error: string | null;
  count: number;
  skip: number;
  limit: number;
  accessStatus: string;
}

const initialState: RoleAssignmentState = {
  data: [],
  status: false,
  error: null,
  count: 0,
  skip: 1,
  limit: 25,
  accessStatus: "",
};

export const fetchRoleAssignmentRequests: any = createAsyncThunk(
  "roleAssignmentRequests/fetchData",
  async (params: {
    skip: number;
    limit: number;
    accessid?: number[];
    status?: string[];
    createdAt?: string[];
    updatedAt?: string[];
    groupname?: string[];
    featurename?: string[];
    permissioname?: string[];
    comment?: string[];
    rolename?: string[];
    subrequestid?: string[];
    email?: string[];
  }) => {
    const response = await axiosInstance.post(
      `/request/data/myrequest?page_no=${params.skip + 1}&page_size=${params.limit}`,
      {
        accessid:
          Array.isArray(params?.accessid) && params?.accessid?.length > 0
            ? params?.accessid
                ?.map((id: any) => id.replace(/rm-/i, "").trim()) // remove rm- and whitespace
                ?.filter((id) => /^\d+$/.test(id)) // keep only numeric strings
            : [],
        status: params.status ?? [],
        createdAt: params.createdAt ?? [],
        updatedAt: params.updatedAt ?? [],
        groupname: params.groupname ?? [],
        featurename: params.featurename ?? [],
        permissioname: params.permissioname ?? [],
        comment: params.comment ?? [],
        rolename: params.rolename ?? [],
        subrequestid: params.subrequestid ?? [],
        email: params.email ?? [],
      },
    );

    if (!response.data || !Array.isArray(response.data.data)) {
      throw new Error("Invalid data format");
    }

    return response.data;
  },
);

//withdaraw
export const withdrawRoleAssignmentRequests: any = createAsyncThunk(
  "roleAssignmentRequests/withdrawData",
  async (params: { requestId: number }) => {
    const response = await axiosInstance.post(`/request/action`, {
      action: "withdraw",
      accessRoleList: {
        accessRoleId: params.requestId,
        approvedRoleIds: [],
        deniedRoleIds: [],
        comment: "",
      },
    });
    return response.data;
  },
);
const roleAssignmentRequestsSlice = createSlice({
  name: "roleAssignmentRequests",
  initialState,
  reducers: {
    setSkip: (state, action: PayloadAction<number>) => {
      state.skip = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setLoadStatus: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload;
    },
    resetData: (state) => {
      state.data = [];
      state.skip = 1;
      state.count = 0;
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleAssignmentRequests.pending, (state) => {
        state.status = true;
      })
      .addCase(fetchRoleAssignmentRequests.fulfilled, (state, action) => {
        state.status = false;
        state.data = action.payload.data ?? [];
        state.count = Number.isNaN(
          Number(
            action.payload?.data ? action.payload?.data[0]?.full_count : 0,
          ),
        )
          ? 0
          : Number(
              action.payload?.data ? action.payload?.data[0]?.full_count : 0,
            );
      })
      .addCase(fetchRoleAssignmentRequests.rejected, (state, action) => {
        state.status = false;
        state.error = action.error.message || "Failed to fetch data";
      })
      .addCase(withdrawRoleAssignmentRequests.pending, (state) => {
        state.status = true;
      })
      .addCase(withdrawRoleAssignmentRequests.fulfilled, (state, action) => {
        state.status = false;
      })
      .addCase(withdrawRoleAssignmentRequests.rejected, (state, action) => {
        state.status = false;
        state.error = action.error.message || "Failed to fetch data";
      });
  },
});

export const { setSkip, setLimit, resetData } =
  roleAssignmentRequestsSlice.actions;
export default roleAssignmentRequestsSlice.reducer as any;
